"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BrandDetailSchema = exports.BusinessBrandSchema = exports.AboutUsDisplaySchema = exports.AboutUsPageThemeSchema = exports.AboutUsPageContentSchema = exports.AboutUsPageHeadlineSchema = exports.AboutUsPageDisplaySchema = exports.LaunchDisplaySchema = exports.LaunchPageThemeSchema = exports.LaunchPageDisplaySchema = exports.BrandSchema = void 0;
const zod_1 = require("zod");
const TokenMisc = __importStar(require("../misc/token"));
//Business Brand
exports.BrandSchema = zod_1.z.object({
    externalIds: TokenMisc.ExternalIdsSchema
});
//Launch Page Display
exports.LaunchPageDisplaySchema = zod_1.z.object({
    mainLogo: zod_1.z.string(),
    secondaryLogo: zod_1.z.string(),
    logoText: zod_1.z.string(),
});
//Launch Page Theme
exports.LaunchPageThemeSchema = zod_1.z.object({
    main: zod_1.z.string(),
    text: zod_1.z.string()
});
//Launch Display
exports.LaunchDisplaySchema = zod_1.z.object({
    display: exports.LaunchPageDisplaySchema,
    theme: exports.LaunchPageThemeSchema
});
//About Us Page Display
exports.AboutUsPageDisplaySchema = zod_1.z.object({
    item: zod_1.z.enum(['video', 'image']),
    imageUrl: zod_1.z.string(),
    videoUrl: zod_1.z.string()
});
//About Us Page Head Line
exports.AboutUsPageHeadlineSchema = zod_1.z.object({
    heading: zod_1.z.string(),
    address: zod_1.z.string(),
    website: zod_1.z.string()
});
//About Us Page Content
exports.AboutUsPageContentSchema = zod_1.z.object({
    description: zod_1.z.string()
});
//About Us Page Theme
exports.AboutUsPageThemeSchema = zod_1.z.object({
    main: zod_1.z.string(),
    heading: zod_1.z.string()
});
//About Us Display
exports.AboutUsDisplaySchema = zod_1.z.object({
    display: exports.AboutUsPageDisplaySchema,
    headLine: exports.AboutUsPageHeadlineSchema,
    content: exports.AboutUsPageContentSchema,
    theme: exports.AboutUsPageThemeSchema
});
//Business Brand
exports.BusinessBrandSchema = zod_1.z.object({
    name: zod_1.z.string(),
    tokenId: zod_1.z.string(),
    externalIds: TokenMisc.ExternalIdsSchema
});
// Brand
exports.BrandDetailSchema = zod_1.z.object({
    archive: zod_1.z.boolean(),
    name: zod_1.z.string(),
    launchScreen: exports.LaunchDisplaySchema,
    aboutUs: exports.AboutUsDisplaySchema,
    products: zod_1.z.array(TokenMisc.ExternalIdsSchema),
    externalIds: TokenMisc.ExternalIdsSchema,
    business: exports.BusinessBrandSchema
});
